package com.ives.utils;
import com.ives.utils.Remoting.DicomImageData;
class DicomUtils {
    public static function getVoxelUnit(dicomImageData:DicomImageData):String{
        if(dicomImageData.modality == 'CT' || dicomImageData.modality == 'CR')
            return 'HU';
        else
            return '';
    }
}
